import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MostaSelect = _resolveComponent("MostaSelect")!

  return (_openBlock(), _createBlock(_component_MostaSelect, {
    "model-value": _ctx.model,
    options: _ctx.options,
    "onUpdate:modelValue": _ctx.toggleOption
  }, null, 8, ["model-value", "options", "onUpdate:modelValue"]))
}